import { YOU_HAVE_BEEN_SUCCESSFULLY_REGISTERED } from 'mk/autogenerated/translations/Signup.sagas.0edfad86013d05f01be13226e212c033'
import { bazaar_single_page_product_grid_url, users_api_auth_signup_url } from 'mk/urls/functions';
import { SIGNUP_FORM_NAME } from 'mk2/apps/users/components/SignupForm';
import {
    SIGNUP_TRIGGER,
    signupAPI,
    SignupNormalizedResponse,
    SignupTriggerAction,
} from 'mk2/apps/users/containers/Signup/Signup.actions';
import { gotoUrlAfterLoginOrSignup, storeLastKnownUsernameCookie } from 'mk2/apps/users/utils';
import { normalizeError, XHRAction, XHRFormError } from 'mk2/helpers/api';
import { handleXHRFormErrorSaga, handleXHRFormSuccessSaga } from 'mk2/helpers/form';
import { getLogger } from 'mk2/logger';
import { getRequestBaseUrl } from 'mk2/reducers';
import { UserEntity, UserSchema } from 'mk2/schemas';
import { getRoutingLocation } from 'mk2/selectors';
import { interpolate } from 'mk2/services/i18n';
import { normalize } from 'normalizr';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

const logger = getLogger('home/Signup.sagas');

interface ApiResponseSignup {
    body: {
        user: UserEntity;
    };
}

function* signup({signupFd, query, iframe, xhr}: SignupTriggerAction & XHRAction) {
    yield put(signupAPI.request(signupFd, query));

    try {
        const response: ApiResponseSignup = yield call(
            () => xhr.post(users_api_auth_signup_url(), {
                signupFd,
                query,
            }),
        );

        const normalizedResponse: SignupNormalizedResponse = normalize(response.body, {user: UserSchema});
        storeLastKnownUsernameCookie(response.body.user.username);

        const msg = interpolate(YOU_HAVE_BEEN_SUCCESSFULLY_REGISTERED, {username: response.body.user.username});
        const baseUrl = yield select(getRequestBaseUrl);
        const location = yield select(getRoutingLocation);
        const gotoUrl = gotoUrlAfterLoginOrSignup(baseUrl, location, bazaar_single_page_product_grid_url());

        if (iframe) {
            // redirect parent page of iframe
            window.top.location.href = gotoUrl;
        }
        yield handleXHRFormSuccessSaga(SIGNUP_FORM_NAME, gotoUrl, msg);
        yield put(signupAPI.success(signupFd, normalizedResponse));
    } catch (error) {
        yield handleXHRFormErrorSaga(SIGNUP_FORM_NAME, error as XHRFormError, logger);
        yield put(signupAPI.failure(signupFd, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(SIGNUP_TRIGGER, signup),
    ]);
}
